import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { Label, Button, Progress } from "reactstrap";
import { Col, Row } from "../../../components/UI/Customstrap/Customstrap";
import GenericButton from "../../../components/UI/Button/Button";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import { getQuestions, updateAnswers, getPersonInfo } from "../../../services/api/person";
import { personInfoSet } from "../../../actions/entities";
import { Icons } from "../../../components/UI/Icon/Icon";
import { showToast } from "../../../utils/helper";
import style from "./InvestorProfileOnboarding.scss";
import { HeaderOnboarding } from "../HeaderOnboarding/HeaderOnboarding";
import { PepOnboarding } from "../PepOnboarding/PepOnboarding";
import MediaQuery from "react-responsive";

export const InvestorProfileOnboarding = ({ toggleMobileSidebar, confirmInvestmentProfile }) => {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [numQuestion, setNumQuestion] = useState(1);
  const [checkedAnswer, setCheckedAnswer] = useState(false);
  const [showPep, setShowPep] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(() => true);
    getQuestions()
      .then(({ response }) => {
        setQuestions(response.questions);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(() => false);
      });
  }, []);

  const setAnswer = (questionIndex, answerIndex) => {
    const newQuestions = [...questions];

    newQuestions.find((question) => question.QuestionId === questionIndex).Answer = newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.map((answerItem) => {
        return {
          ...answerItem,
          AnswerIsResponse: false,
        };
      });

    newQuestions
      .find((question) => question.QuestionId === questionIndex)
      .Answer.find((answer) => answer.AnswerId === answerIndex).AnswerIsResponse = true;

    setQuestions(newQuestions);
  };

  const onConfirm = () => {
    const newQuestions = questions.filter((questionItem) => {
      if (questionItem.Answer.find((answerItem) => answerItem.AnswerIsResponse)) return questionItem;
    });
    if (newQuestions.length < questions.length) {
      showToast("Debe responder todas las preguntas", true);
      return;
    } else {
      setLoading(() => true);
      updateAnswers({ sdtQuestion: questions })
        .then(({ response }) => {
          if (response.sdtresult.Code !== 200) showToast("Error enviando respuestas", true);
          else {
            getPersonInfo()
              .then(({ response }) => {
                dispatch(personInfoSet(response.personInfo));
              })
              .catch((err) => console.error(err))
              .finally(() => {
                setLoading(() => false);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
      toggleShowPep();
    }
  };

  const toggleShowPep = () => {
    confirmInvestmentProfile();
    setShowPep(true);
  };

  const Question = () => {
    return (
      <div>
        {questions.slice(numQuestion - 1, numQuestion).map((question, indexQuestion) => {
          return (
            <form key={indexQuestion} className={style.questionForm}>
              <p className={style.questionTitle}>{question.QuestionDescription}</p>
              {question.Answer.map((answer, index) => {
                const key = `${question.QuestionId}-${index}`;

                return (
                  <div key={key} className={style.answerRow}>
                    <Button
                      className={style.radioButton}
                      onClick={() => {
                        setCheckedAnswer(key);
                        setAnswer(question.QuestionId, answer.AnswerId);
                      }}
                    >
                      {checkedAnswer == key ? (
                        <Icons.RadioCheckedAnswer size="sm" className={style.icon} />
                      ) : (
                        ""
                      )}
                    </Button>
                    <label
                      onClick={() => {
                        setCheckedAnswer(key);
                        setAnswer(question.QuestionId, answer.AnswerId);
                      }}
                      className={style.answerText}
                    >
                      {answer.AnswerDescription}
                    </label>
                  </div>
                );
              })}
            </form>
          );
        })}
      </div>
    );
  };

  const handleChangeQuestion = () => {
    if (checkedAnswer) {
      setNumQuestion(numQuestion + 1);
      <Question />;
      setCheckedAnswer((prevStateAnswer) => !prevStateAnswer);
      if (numQuestion >= questions.length) onConfirm();
    } else {
      showToast("Debe seleccionar una opción para continuar", true);
    }
  };

  return (
    <div className={style.profileContainer}>
      <HeaderOnboarding title="Conocé tu perfil de inversión" toggleMobileSidebar={toggleMobileSidebar} />
      <Row className={style.headerTitle}>
        <Label>Conocé tu perfil de inversión</Label>
        <MediaQuery maxWidth={576}>
          <div className={style.divider}></div>
        </MediaQuery>
      </Row>
      <Row className={style.dataRow}>
        <Col className={style.colInvestor}>
          <div className={style.firstText}>
            Respondé las siguientes preguntas
          </div>
          <div className={style.questionContainer}>
            <Question />
            <MediaQuery minWidth={576}>
              <div className={style.buttonContainer}>
                <GenericButton
                  label={numQuestion < questions.length ? "Continuar" : "Enviar respuestas"}
                  rounded
                  padding={"8px 46px"}
                  primary
                  right
                  handleClick={handleChangeQuestion}
                  iconSvg={[{ width: "16px", item: confirmIcon }]}
                ></GenericButton>
              </div>
            </MediaQuery>
            <div className={style.progressContainer}>
              <div className={style.textBar}>{numQuestion + " de " + questions.length}</div>
              <Progress
                className={style.progressBar}
                value={(numQuestion * 100) / questions.length}
              ></Progress>
            </div>
          </div>
          <MediaQuery maxWidth={576}>
            <div className={style.buttonContainer}>
              <GenericButton
                label={numQuestion < questions.length ? "Continuar" : "Enviar respuestas"}
                rounded
                padding={"8px 46px"}
                primary
                right
                handleClick={handleChangeQuestion}
                iconSvg={[{ width: "16px", item: confirmIcon }]}
              ></GenericButton>
            </div>
          </MediaQuery>
        </Col>
      </Row>
      {showPep && <PepOnboarding toggleMobileSidebar={toggleMobileSidebar} />}
    </div>
  );
};
